export const reverseCurrency = {
  methods: {
    reverseCurrency(price) {
      if (price != undefined) return price.toString().replaceAll(',', '')
    },
  },
}
